.field{
  @apply border border-gray-300 px-3 py-2 rounded focus-visible:border-gray-600 focus:outline-none
}